import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { FooterComponent } from '../footer/footer.component';
import { HeaderComponent } from '../header/header.component';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { SicotService } from '../sicot.service';
import { Struttura } from '../types/Struttura';

@Component({
    selector: 'app-punti-erogazione-2',
    imports: [
        HeaderComponent,
        FooterComponent,
        MatCardModule,
        MatTableModule,
        MatProgressSpinnerModule,
        MatFormFieldModule,
        MatInputModule,
        MatPaginatorModule
    ],
    templateUrl: './punti-erogazione-2.component.html',
    styleUrl: './punti-erogazione-2.component.css'
})
export class PuntiErogazione2Component implements OnInit, AfterViewInit {

    strutture: Struttura[] = [];
    dataSource = new MatTableDataSource<Struttura>([]);
    caricamento = true;
    errore: string | null = null;
    displayedColumns: string[] = ['id', 'codice', 'denominazione'];

    @ViewChild(MatPaginator) paginator!: MatPaginator;

    constructor(
        private sicotService: SicotService,
        private router: Router
    ) {}

    ngOnInit(): void {
        this.sicotService.getStrutture().subscribe({
            next: (data) => {
                this.strutture = data;
                this.dataSource = new MatTableDataSource<Struttura>(data);
                this.dataSource.paginator = this.paginator;
                this.dataSource.filterPredicate = (row: Struttura, filter: string) => {
                    const f = filter.trim().toLowerCase();
                    if (!f) return true;
                    const id = row.id != null ? String(row.id) : '';
                    const codice = (row.codice ?? '').toLowerCase();
                    const denominazione = (row.denominazione ?? '').toLowerCase();
                    return id.includes(f) || codice.includes(f) || denominazione.includes(f);
                };
                this.caricamento = false;
            },
            error: (err) => {
                this.errore = 'Errore nel caricamento delle strutture.';
                this.caricamento = false;
            }
        });
    }

    ngAfterViewInit(): void {
        this.dataSource.paginator = this.paginator;
    }

    applyFilter(event: Event): void {
        const filterValue = (event.target as HTMLInputElement).value;
        this.dataSource.filter = filterValue.trim().toLowerCase();
        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
    }

    goToDettaglio(id: number | undefined): void {
        if (id != null) {
            this.router.navigate(['/struttura', id]);
        }
    }
}
